import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Select,
} from '@chakra-ui/react'
import { useControleIlustracaoContext } from '../../../contexts/ControleIlustracaoProvider'
import { useState } from 'react'

export function ModalCompreGanhe() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [pendencia, setPendencia] = useState(null)

  const { setFormValues, formValues, modelos, handleCompreGanhe } = useControleIlustracaoContext()

  const { data } = modelos

  function handlePendenciaCompreGanhe(idPendencia) {
    //setFormValues({ ...formValues, modelo_arte: idPendencia })
    setPendencia(idPendencia)
  }

  function onFilter() {
    setFormValues({ ...formValues, compre_ganhe: 1, modelo_arte: pendencia })

    handleCompreGanhe()
    onClose()
  }

  return (
    <>
      <Button fontSize="12px" fontWeight="normal" size="sm" maxW="147px" bgColor="#378BBF" w="100%" colorScheme="blue" onClick={onOpen}>
        Compre Ganhe
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filtro Compre Ganhe</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Select size="sm" onChange={(e) => handlePendenciaCompreGanhe(e.target.value)}>
              <option value="" placeholder="Selecione a pendencia">
                Pendência Compre Ganhe
              </option>
              {data?.map((item, index) => (
                <option key={index} value={item.modelo_arte}>
                  Modelo arte - {item.modelo_arte}
                </option>
              ))}
            </Select>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onFilter}>
              Filtrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
